import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiInstance } from '../../Apis/Axios';
import { ClearGetEmployeeProviderByEmail, ClearGetEmployeeProviderByPhoneNumber } from './EmployeeProviderSlice';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import { UploadProviderImage, SaveProviderImage } from '../Providers/providersApi';

import { getSelfie } from '../CompanyEmployees/CompanyEmployeesApi';
import {accessMethodModel} from "../../enums/accessMethodEnum";
import {ORDER_SERVICE, SUPPLIER_SERVICE} from "../EndPoints";
//   @create order flow start

// create purshase order  (supplier-module order-controller) (done)
export const CreateSupplierOrder = createAsyncThunk(
    'employeeProvider/createSupplierOrder',
    async (params) => {
        const result = await apiInstance
            .post('order-service/v1/create', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const EmployeeFlowUpdateOrder = createAsyncThunk(
    'employeeProvider/employeeFlowUpdateOrder',
    async (params) => {
        const result = await apiInstance
            .put(ORDER_SERVICE.employeeFlowUpdateOrder, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// see detials order  (provider-module order-controller)  (done  (but need to fix status))
export const GetSupplierOrder = createAsyncThunk(
    'employeeProvider/getSupplierOrder',
    async (params) => {
        const result = await apiInstanceV2
            .get(`order-service/get-by-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Get list of provider (done)
export const GetEmployeeProviderLists = createAsyncThunk(
    'employeeProvider/getEmployeeProviderLists',
    async () => {
        const result = await apiInstanceV2
            .get('supplier-service/get-all')
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get list of gender
export const GetGenderListProvider = createAsyncThunk(
    'employeeProvider/getGnderListProvider',
    async () => {
        const result = await apiInstance
            .get('gender-service/get-all')
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// Get provider by email  (user-module user-controller) (done )
export const GetEmployeeProviderByEmail = createAsyncThunk(
    'employeeProvider/getEmployeeProviderByEmail',
    async (params, { dispatch }) => {
        const result = await apiInstance
            .get(`user-service/get-by-email/${params}`, {
                'content-type': 'application/json',
            })
            .then(function (response) {
                toast.success('User email exist');
                return response;
            })
            .catch(function (error) {
                dispatch(ClearGetEmployeeProviderByEmail());

                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Get provider by phoneNumber (user-module user-controller) (done)
export const GetEmployeeProviderByPhoneNumber = createAsyncThunk(
    'employeeProvider/getEmployeeProviderByPhoneNumber',
    async (params, { dispatch }) => {
        const result = await apiInstance
            .get(`user-service/get-by-phone-number/${params}`)
            .then(function (response) {
                toast.success('User Phone number exist');
                return response;
            })
            .catch(function (error) {
                dispatch(ClearGetEmployeeProviderByPhoneNumber());

                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// /corporate-user-pre-prod-v1/document-service/approve-external-document (done)
export const ApproveExternalDocument = createAsyncThunk(
    'employeeProvider/approveExternalDocument',
    async (params) => {
        const result = await apiInstance
            .post('document-service/supplier/approve-document', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get user docs
export const GetUserDocumentsEmployee = createAsyncThunk(
    'employeeProvider/getUserDocumentsEmployee',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`document-service/employee/get-all/by-user-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// set document exernal value
export const SetToExternalEmployee = createAsyncThunk(
    'employeeProvider/setToExternalEmployee',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put('document-service/employee/set-comment', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// create document employee value
export const CreateToExternalEmployee = createAsyncThunk(
    'employeeProvider/createToExternalEmployee',
    async (params) => {
        const result = await apiInstance
            .post('document-service/employee/create-to-employee', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// download company employee  files
export const DownloadCompanyFileEmployee = createAsyncThunk(
    'employeeProvider/downloadCompanyFileEmployee',
    async (params) => {
        const option = 'company_document_employee';
        const result = await apiInstance
            .get(`image-service/download-by-id/${params}/option/${option}`, { responseType: 'blob' })
            .then(function (response) {
                // toast.success("successfully downloaded")
                const url = window?.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Car_Image.png'); // or any other extension
                document.body.appendChild(link);
                link.click();
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// download employee  files
export const DownloadEmployeeFile = createAsyncThunk(
    'employeeProvider/downloadEmployeeFile',
    async (params) => {
        const option = 'document_employee';
        const result = await apiInstance
            .get(`image-service/download-by-id/${params}/option/${option}`)
            .then(function (response) {
                const url = window?.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'image.jpg'); // or any other extension
                document.body.appendChild(link);
                link.click();
                // toast.success("successfully downloaded")
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//  create supplier Employee
export const CreateEmployeeSupplier = createAsyncThunk(
    'employeeProvider/createEmployeeSupplier',
    async (params, { dispatch }) => {
        const result = await apiInstance
            .post('supplier-service/v1/create', params?.data)
            .then(function (response) {
                const imgData = {
                    user: {
                        id: response?.data?.data?.userId,
                    },
                    accessMethod: { id: accessMethodModel.FACE_RECOGNITION.id },
                    description: 'Face recognition',
                };
                // want to update or create image
                if (params?.file != '' && params?.file != null) {
                    dispatch(UploadProviderImage({ imgData, file: params?.file }));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
//  get supplier data by it id
export const GetEmployeeSupplierByItId = createAsyncThunk(
    'employeeProvider/getEmployeeSupplierByItId',
    async (params) => {
        const result = await apiInstance
            .get(`supplier-service/v1/get-by-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//  update supplier employee
export const UpdateSupplier = createAsyncThunk(
    'employeeProvider/updateSupplier',
    async (params, { dispatch }) => {
        const { data, file, updateImage, setModified } = params;

        try {
            const response = await apiInstance.put(
                SUPPLIER_SERVICE.updateSupplier,
                data,
            );

            const userId = response?.data?.data?.userId;

            const imgData = {
                user: { id: userId },
                accessMethod: { id: accessMethodModel.FACE_RECOGNITION.id },
                description: 'Face recognition',
            };

            if (file) {
                if (updateImage) {
                    const selfie = await dispatch(getSelfie(userId)).unwrap();
                    await dispatch(
                        SaveProviderImage({
                            id: selfie?.data?.data?.id,
                            file,
                        }),
                    );
                } else {
                    await dispatch(
                        UploadProviderImage({ imgData, file }),
                    );
                }
            }

            setModified?.(true);

            return {
                data: response.data,
                status: response.status,
            };
        } catch (error) {
            setModified?.(true);

            return {
                data: error?.response?.data,
                status: error?.response?.status,
            };
        }
    },
);
